import React, { useState } from 'react';
import { View, ScrollView, KeyboardAvoidingView } from 'react-native';

import PropTypes from 'prop-types';

import { withAsyncAction } from '@vfgroup-oneplatform/foundation/Components/SpinnerOverlay';
import { LightThemeColors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import PaymentError from '../../Components/PaymentError';
import AddPaymentForm from '../AddPaymentCard';

import styles from './AddPayment.styles';
import ScanCard from './Components/ScanCard';

const closePaymentErrorModal = setIsPaymentErrorModalVisible => {
  setIsPaymentErrorModalVisible(false);
};

const onAddPaymentFailed = (error, setPaymentErrorData, setIsPaymentErrorModalVisible) => {
  console.log("🚀 ~ file: AddPayment.js:21 ~ onAddPaymentFailed ~ error:", error)
  setTimeout(() => {
    setPaymentErrorData(error);
    setIsPaymentErrorModalVisible(true);
  }, 500);
};
const _onPressSaveCard = ({
  cardDataParam,
  onAsyncActionPressed,
  onPressSaveCard,
  setPaymentErrorData,
  setIsPaymentErrorModalVisible,
  setCurrentCardData,
  onAddPaymentSuccess,
}) => {
  setPaymentErrorData({});
  onAsyncActionPressed(
    () => onPressSaveCard(cardDataParam),
    onAddPaymentSuccess,
    err => onAddPaymentFailed(err, setPaymentErrorData, setIsPaymentErrorModalVisible),
  );
  setCurrentCardData(cardDataParam);
};

const AddPayment = ({
  onAsyncActionPressed,
  hideScanCard,
  hideScanCardDescription,
  onPressScan,
  hiddenFields,
  cardData,
  onPressSaveCard,
  withTray,
  validations,
  onPressErrorAction,
  onKeyboardDidShow,
  onKeyboardDidHide,
  images,
  onAddPaymentSuccess,
}) => {
  const [paymentErrorData, setPaymentErrorData] = useState({});
  const [isPaymentErrorModalVisible, setIsPaymentErrorModalVisible] = useState(false);
  const theme = useTheme() || LightThemeColors;
  const [currentCardData, setCurrentCardData] = useState({});

  return (
    <KeyboardAvoidingView behavior={'position'}>
      <ScrollView contentContainerStyle={styles.contentContainerStyle(withTray)}>
        <View style={styles.wrapper} testID={FrameworkTestKeys.AddPaymentView}>
          {!hideScanCard && (
            <ScanCard
              scanCardDescription={'payment_add_scan_card_description'}
              hideScanCardDescription={hideScanCardDescription}
              onPressScan={onPressScan}
            />
          )}
          <View style={styles.cardWrapper(theme)}>
            <AddPaymentForm
              hideSaveCardForLater
              hiddenFields={hiddenFields}
              cardData={cardData}
              onPressSaveCard={cardDataParam =>
                _onPressSaveCard({
                  cardDataParam,
                  onAsyncActionPressed,
                  onPressSaveCard,
                  setPaymentErrorData,
                  setIsPaymentErrorModalVisible,
                  setCurrentCardData,
                  onAddPaymentSuccess,
                })
              }
              onKeyboardDidShow={onKeyboardDidShow}
              onKeyboardDidHide={onKeyboardDidHide}
              withHandleKeyboardOpen={false}
              validations={validations}
              savingError={paymentErrorData}
            />
          </View>
        </View>
        <PaymentError
          isVisible={isPaymentErrorModalVisible}
          currentCardData={currentCardData}
          onPressErrorAction={onPressErrorAction}
          onPressErrorDefaultAction={cardDataParam =>
            _onPressSaveCard({
              cardDataParam,
              onAsyncActionPressed,
              onPressSaveCard,
              setPaymentErrorData,
              setIsPaymentErrorModalVisible,
              setCurrentCardData,
              onAddPaymentSuccess,
            })
          }
          closeModal={() => closePaymentErrorModal(setIsPaymentErrorModalVisible)}
          error={paymentErrorData}
          images={images}
        />
      </ScrollView>
    </KeyboardAvoidingView>
  );
};
AddPayment.defaultProps = {
  hideScanCard: false,
  hideScanCardDescription: false,
  onPressScan: () => { },
  hiddenFields: [],
  cardData: {},
  onPressSaveCard: () => { },
  onKeyboardDidShow: () => { },
  onKeyboardDidHide: () => { },
  withTray: false,
};
AddPayment.propTypes = {
  onPressErrorAction: PropTypes.func,
  hideScanCard: PropTypes.bool,
  hideScanCardDescription: PropTypes.bool,
  onPressScan: PropTypes.func,
  hiddenFields: PropTypes.arrayOf(PropTypes.string),
  cardData: PropTypes.object,
  onPressSaveCard: PropTypes.func,
  withTray: PropTypes.bool,
  validations: PropTypes.shape({
    cardName: PropTypes.func,
    nameOnCard: PropTypes.func,
    expirationData: PropTypes.func,
    ccvNo: PropTypes.func,
    cardNo: PropTypes.func,
  }),
  onKeyboardDidShow: PropTypes.func,
  onKeyboardDidHide: PropTypes.func,
  onAsyncActionPressed: PropTypes.func,
  images: PropTypes.object,
  onAddPaymentSuccess: PropTypes.func,
};
export { closePaymentErrorModal, onAddPaymentFailed, _onPressSaveCard };
export default withAsyncAction(AddPayment);
